import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import paymentReducer from './paymentSlice';
import documentUploadReducer from './documentUploadSlice';
import adminPaymentReducer from './adminPaymentSlice';
import walletReducer from './slices/walletSlice';
import fidelityPaymentReducer from './slices/fidelityPaymentSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    payment: paymentReducer,
    documentUpload: documentUploadReducer,
    adminPayment: adminPaymentReducer,
    wallet: walletReducer,
    fidelityPayment: fidelityPaymentReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
